export default __webpack_public_path__ + "static/install-istio1-925c2de6f52d84cd8f2d5936eb13b3fd.webp";